import { makeAutoObservable, runInAction } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { type PageLayoutStore } from 'shared/layout'
import { logger } from 'shared/lib'
import { PowerDialerApi } from 'entities/PowerDialer/api/powerDialer'
import { PowerDialer } from 'entities/PowerDialer/model/PowerDialer'
import type { IResponsePowerDialer } from 'entities/PowerDialer/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { PowerDialerRoutes } from 'pages/powerDialer'
import { PowerDialerContactsStore } from 'pages/powerDialer/pages/view/store/powerDialerContactsStore'

export class PowerDialerViewStore {
  readonly powerDialerId: number | null
  private readonly _pageLayoutStore: PageLayoutStore
  private _powerDialer: PowerDialer | null = null
  private _isLoading = true
  private _powerDialerContactsStore: PowerDialerContactsStore

  constructor(
    powerDialerId: string | number | undefined,
    pageLayoutStore: PageLayoutStore,
    private _entities: IEntitiesStore
  ) {
    this.powerDialerId = Number(powerDialerId)
    this._pageLayoutStore = pageLayoutStore
    this._powerDialerContactsStore = new PowerDialerContactsStore(this._entities)

    makeAutoObservable(this)
  }

  init = async () => {
    try {
      if (!this.powerDialerId) return
      const {
        data: { data },
      } = await PowerDialerApi.getPowerDialerById(this.powerDialerId)
      const powerDialer = new PowerDialer(data, this._entities)
      this._powerDialer = powerDialer
      this._powerDialerContactsStore.init(powerDialer)
    } catch (e) {
      logger.error(e)

      uiStore.changeRoute({
        path: `/${PowerDialerRoutes.root}`,
      })
    } finally {
      runInAction(() => {
        this._isLoading = false
      })
    }
  }

  updatePowerDialerViewItem = (updatedPowerDialerResponse: IResponsePowerDialer) => {
    if (!this._powerDialer) return
    this._powerDialer.status = updatedPowerDialerResponse.status
  }

  get powerDialerContactsStore() {
    return this._powerDialerContactsStore
  }

  get isLoading() {
    return this._isLoading
  }

  get powerDialer() {
    return this._powerDialer
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }

  dispose() {
    this._powerDialerContactsStore.dispose()
  }
}
